import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom'
import "./HeaderMob.scss";
import logo from './assets/logo.jpg';
import search from './assets/search2.svg';
import wishList from './assets/heart3.svg';
import cartBag from './assets/cart2.svg';
import axios from "axios";
import { getData } from "./Data";

import arb1 from './assets/arabic-1.svg';
import { IoIosArrowDown } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import { IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../Contexts/ProfileContext";
import { mobCheckoutGuard, CHECKOUT_PATHS, getCheckoutLeaveDestination } from "../../hooks/useMobCheckoutLeaveConfirm";
import { HeaderBrandMark } from "../../Brand/HeaderBrandMark";
import { BUSINESS } from "../../Legal/legalContent";

export function HeaderMob({ headerToggle, setHeaderToggle, setSelectedHeader }) {
    const { profileData } = useProfile();
    const navigate = useNavigate();
    const location = useLocation();
    const [guestCartVersion, setGuestCartVersion] = useState(0);
    const [badgePulse, setBadgePulse] = useState(false);
    const isCheckoutPage = CHECKOUT_PATHS.has(location.pathname);
    const showBackArrow = isCheckoutPage;

    useEffect(() => {
        const handler = () => setGuestCartVersion((v) => v + 1);
        window.addEventListener('guestCartUpdated', handler);
        return () => window.removeEventListener('guestCartUpdated', handler);
    }, []);

    useEffect(() => {
        const handler = () => {
            setBadgePulse(true);
            const t = setTimeout(() => setBadgePulse(false), 350);
            return () => clearTimeout(t);
        };
        const onPulse = () => { setBadgePulse(true); setTimeout(() => setBadgePulse(false), 350); };
        window.addEventListener('cartBadgePulse', onPulse);
        return () => window.removeEventListener('cartBadgePulse', onPulse);
    }, []);

    const handleHeaderBack = () => {
        if (mobCheckoutGuard.active && typeof mobCheckoutGuard.promptLeave === 'function') {
            mobCheckoutGuard.promptLeave('back');
            return;
        }
        // Empty cart (guard off) still shows the back arrow — leave without confirm.
        if (isCheckoutPage) {
            const destination = getCheckoutLeaveDestination(location.pathname) || '/';
            navigate(destination === location.pathname ? '/' : destination, { replace: true });
            return;
        }
        if (window.history.length > 1) {
            window.history.back();
            return;
        }
        navigate('/');
    };

    const handleLogoClick = () => {
        if (location.pathname === '/') return;
        if (mobCheckoutGuard.active && typeof mobCheckoutGuard.promptLeave === 'function') {
            mobCheckoutGuard.promptLeave('/');
            return;
        }
        navigate('/');
    };

    const handleGuardedNavigate = (path) => {
        if (mobCheckoutGuard.active && typeof mobCheckoutGuard.promptLeave === 'function') {
            mobCheckoutGuard.promptLeave(path);
            return;
        }
        navigate(path);
    };

    return (
        <div className="header-mob">
            <div className="site-nav-container">
                <div id="header-menu-icon" class="header-icon menu-icon" onClick={() => {
                    if (showBackArrow) {
                        handleHeaderBack();
                        return;
                    }
                    setHeaderToggle(!headerToggle);
                }}>
                    {showBackArrow ?
                        <svg viewBox="0 0 24 24">
                            <path fill="white" fillrule="evenodd" d="M20.25 11.25H5.555l6.977-6.976a.748.748 0 000-1.056.749.749 0 00-1.056 0L3.262 11.43A.745.745 0 003 12a.745.745 0 00.262.57l8.214 8.212a.75.75 0 001.056 0 .748.748 0 000-1.056L5.555 12.75H20.25a.75.75 0 000-1.5"></path>
                        </svg>
                        :
                        <svg viewBox="0 0 24 24">
                            <path d="M3.444 5.422a.733.733 0 110-1.466h17.047a.733.733 0 110 1.466H3.444zm0 7.111a.733.733 0 110-1.466h17.047a.733.733 0 110 1.466H3.444zm0 7.111a.733.733 0 110-1.466h17.047a.733.733 0 110 1.466H3.444z" fill="white" fillrule="evenodd"></path>
                        </svg>
                    }
                </div>

                <div
                    className="nav-icon header-brand header-brand--native"
                    onClick={handleLogoClick}
                    role="link"
                    aria-label={`${BUSINESS.brandName} — Home`}
                >
                    <HeaderBrandMark />
                </div>

                <div className="header-actions pull-right">
                    {/* <div>
                        <img src={profile} />
                    </div> */}
                    {/* <IoSearch /> */}

                    <span className="profile" onClick={() => {
                        if (mobCheckoutGuard.active && typeof mobCheckoutGuard.promptLeave === 'function') {
                            // Leave checkout first, then open search on the leave destination
                            mobCheckoutGuard.promptLeave({
                                onAfterLeave: () => setSelectedHeader(3),
                            });
                            return;
                        }
                        setSelectedHeader(3);
                    }}>
                        {/* <img src={search} /> */}
                        {/* <IoSearch stroke="white" fill="#3e4152" size='26px'/> */}

                        <svg width="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.9536 14.9458L21 21M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </span>
                    <span className="wishList" onClick={() => handleGuardedNavigate("/wishlist")}>
                        {/* <img src={wishList} /> */}

                        <svg width="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    <span className="cartBag cart-container" onClick={() => {
                        if (location.pathname === '/cart') return;
                        handleGuardedNavigate("/cart");
                    }}>
                        <div className="cart-icon-wrapper">
                            <svg width="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.15" d="M4.97043 9.81038C5.06819 8.78391 5.93031 8 6.96142 8H17.0386C18.0697 8 18.9318 8.78391 19.0296 9.81038L19.7915 17.8104C19.9033 18.9846 18.9799 20 17.8005 20H6.19952C5.02004 20 4.0967 18.9846 4.20853 17.8104L4.97043 9.81038Z" fill="none" />
                                <path d="M8 11.01V11M16 11.01V11M8 8V7C8 5.93913 8.42143 4.92172 9.17157 4.17157C9.92172 3.42143 10.9391 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.93913 16 7V8M8 8H6.84027C5.80009 8 4.93356 8.79732 4.84718 9.83391L4.18051 17.8339C4.08334 18.9999 5.00352 20 6.1736 20H17.8264C18.9965 20 19.9167 18.9999 19.8195 17.8339L19.1528 9.83391C19.0664 8.79732 18.1999 8 17.1597 8H16M8 8H16" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            {(() => {
                                const isGuest = localStorage.getItem('guestUser') === 'true';
                                const count = (guestCartVersion, isGuest)
                                    ? JSON.parse(localStorage.getItem('guestCart') || '[]').reduce((s, i) => s + (i.selectedQty || 1), 0)
                                    : profileData?.data?.cartCount || 0;
                                return count > 0 && (
                                    <span className={`cart-badge ${badgePulse ? 'cart-badge--pulse' : ''}`}>
                                        {count > 99 ? '99+' : count}
                                    </span>
                                );
                            })()}
                        </div>
                    </span>
                </div>
            </div>


            {/* <div className="my">
                <img src={profile} />
            </div> */}
        </div>
    )
}